import { ReactComponent as CheckOn } from "assets/morning/icon/checkOn.svg";
import { ReactComponent as CheckOff } from "assets/morning/icon/checkOff.svg";

type CheckBoxProps = {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    className?: string;
    label?: string;
    disabled?: boolean;
    size?: string;
    labelClassName?: string;
    customLabel?: React.ReactNode;
    offClassName?: string;
};

const CheckBox = ({ checked = false, onChange, className, label, disabled, size, labelClassName, customLabel, offClassName }: CheckBoxProps) => {
    const handleToggle = () => {
        if (disabled) return;

        if (onChange) {
            onChange(!checked);
        }
    };

    return (
        <div className={`flex items-center ${disabled ? "cursor-default" : "cursor-pointer"} ${className}`} onClick={handleToggle}>
            <div className={`flex items-center justify-center ${size || "w-7 h-7"}`}>
                {checked ? <CheckOn className={size} /> : <CheckOff className={`${size} ${offClassName}`} />}
            </div>
            {label && <p className={`${labelClassName} text-[#1b1c1e] text-[18px] ml-2 font-[500]`}>{label}</p>}
            {customLabel && customLabel}
        </div>
    );
};

export default CheckBox;
